<template>
  <div class="flex">
    <span class="inline-block my-2 center" style="width: 72px">{{ props.title }}：</span>
    <ul class="flex flex-wrap items-center">
      <li
        :class="{ cur: item.id == selectedId }"
        class="px-3 py-1 mx-2 mb-3 cursor-pointer"
        v-for="item of props.list"
        :key="item.id"
        @click="selectedHandle(item)">
        {{ item.text }}
      </li>
    </ul>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from "vue";
interface ItemSpec {
  id: string | number;
  text: string;
}
const props = defineProps({
  title: String,
  list: {
    type: Array as PropType<ItemSpec[]>,
    default: () => [],
  },
  selectedId: {
    type: Number,
    default: 99,
  },
});
const emit = defineEmits(["selected"]);
onMounted(() => {
  // console.log(props.list);
});
const currentId = computed({
  get() {
    return props.selectedId;
  },
  set(newValue) {
    return newValue;
  }
});
const selectedHandle = (item: { id: string; text: string }) => {
  // console.log("selectedHandle", item);
  emit("selected", item);
  currentId.value = Number(item.id);
};
</script>

<style lang="postcss" scoped>
li.cur {
  background-color: #2bb9c3;
  border-radius: 4px;
  color: #fff;
  cursor: auto;
}
</style>
